import _ from 'lodash';
import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { icon } from './../../../icons/icons';

// actions
import * as actions from './../../../actions/actions';

class EditButtons extends React.Component {
    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
        this.share = this.share.bind(this);
    }

    hasEmptyPage() {
        let isPageEmpty = false;

        _.forEach(this.props.pages.byId, (page) => {
            if (_.isEmpty(page.widgets)) {
                isPageEmpty = true;
            }
        });

        if (isPageEmpty) {
            return true;
        }
        return false;
    }

    hasEmptyName() {
        if (!_.isNull(this.props.app.name)) {
            return false;
        }
        return true;
    }

    save(e) {
        e.preventDefault();

        if (this.hasEmptyPage()) {
            this.props.actions.setModal('WARNING', 'Warning', 'Please delete empty pages or add widgets before saving.');
        } else if (this.hasEmptyName()) {
            this.props.actions.setModal('SAVE');
        } else {
            this.props.actions.save();
        }
    }

    share(e) {
        e.preventDefault();
        this.props.actions.setModal('SHARE');
    }

    render() {
        const { app } = this.props;
        return (
            <div className="edit-btns">
                {(app.shareUrl) ?
                    <div className="share-btns">
                        <a href={app.shareUrl} className="share" target="_blank" rel="noopener noreferrer" title="Share URL" onClick={this.share}>{icon.share()}</a>
                        <a href={app.shareUrl} className="view" target="_blank" rel="noopener noreferrer" title="View URL">{icon.view()}</a>
                    </div>
                : null }
                <div title="Save Quick Response" className="save" onClick={this.save}>SAVE</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    pages: state.pages,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

EditButtons.propTypes = {
    app: PropTypes.object.isRequired,
    pages: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditButtons);




// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/UI/EditButtons.jsx